<template>
    <option value="active">active</option>
    <option value="inactive">inactive</option>
</template>
